export interface EconomicIntegrationConfig {
  tokenParamName: string;
  localStorageKey: string;
  redirectPath: string;
  integrationPath: string;
}

export const ECONOMIC_CONFIG: EconomicIntegrationConfig = {
  tokenParamName: "token",
  localStorageKey: "economicToken",
  redirectPath: "/",
  integrationPath: "/integration/e-conomic/connect",
};

export const extractAndStoreEconomicToken = (): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  const economicToken = urlParams.get(ECONOMIC_CONFIG.tokenParamName);

  if (economicToken) {
    localStorage[ECONOMIC_CONFIG.localStorageKey] = economicToken;
    return economicToken;
  }

  return null;
};

export const isEconomicIntegrationPath = (): boolean => {
  return window.location.pathname.includes(ECONOMIC_CONFIG.integrationPath);
};

export const getStoredEconomicToken = (): string | null => {
  return localStorage.getItem(ECONOMIC_CONFIG.localStorageKey);
};

export const clearEconomicToken = (): void => {
  localStorage.removeItem(ECONOMIC_CONFIG.localStorageKey);
};

export const setPostIntegrationFlags = (): void => {
  localStorage.setItem("shouldStartFirstSync", "true");
  localStorage.setItem("shouldSelectWelcomeConversation", "true");
};

export const getEconomicAuthUrl = (): string => {
  return import.meta.env.VITE_TAILSCALE_FUNNEL_BASE_URL
    ? `https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=zDuGmuztIyDCRvPmk5heLjPY8rfbYxlc6Tqf1p2MEbU1&redirectUrl=${encodeURIComponent(
        `${import.meta.env.VITE_TAILSCALE_FUNNEL_BASE_URL}/integration/e-conomic/connect`,
      )}`
    : "https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=2W6NhwKKvweaPWY19vxXs0mn1GtiVk49xIYOq3R2z2o&redirectUrl=https%3A%2F%2Fasktally.com%2Fintegration%2Fe-conomic%2Fconnect";
};
